<template>
  <div :class="fieldStyling">
    <div class="field__label flex items-center justify-between">
      <FieldLabel :field="field" />
      <ErrorMessage
        v-if="errors"
        :error="errorMessage"
      />
    </div>
    <div>
      <Multiselect
        v-model="value"
        :for="`${field.attributes.slug}-field`"
        :options="options"
        :placeholder="`Select Option`"
        :multiple="true"
        :class="{ 'error': errors.length }"
        :disabled="isDisabled"
      />
    </div>
    <HelpText
      v-if="field.attributes.help"
      class="mt-6"
      :help-text="field.attributes.help"
    />
  </div>
</template>

<script type="text/babel">
import Multiselect from 'vue-multiselect'
import HelpText from './HelpText'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import inputField from 'FormBuilder/Resources/assets/js/mixins/input-field.js'

export default {
  name: 'MultiSelectField',
  components: {
    ErrorMessage,
    FieldLabel,
    HelpText,
    Multiselect,
  },
  mixins: [inputField],
  data() {
    return {
      value: this.initialState ? JSON.parse(this.initialState) : [],
    }
  },
  computed: {
    options() {
      return this.field.attributes.field_meta.options
    },
    fieldStyling() {
      return this.formLocation === 'request-access' ? '' : 'field field--select'
    },
  },
}
</script>
